import styled from "styled-components";
import { themeGet } from "../../../src/theming";
import { space } from "../../../src/theming/styledSystem";
import { BadgeWidthProps } from "./types";

export const WrapperContainer = styled.div`
  margin: ${themeGet("space.space-3")};
  flex-direction: row;
  position: relative;
  ${space}
`;

export const ChildrenContainer = styled.div`
  position: relative;
  width: auto;
`;

export const Positioner = styled.div<BadgeWidthProps>`
  position: absolute;
  flex-wrap: wrap;
  top: -20%;
  right: -${(props) => props.badgeWidth * 0.5}px;
  min-width: ${(props) => props.badgeWidth}px;
  z-index: 1;
`;
